import type { DayAheadBidTableContext } from './DayAheadBidTable.types'

export function serializeDayAheadBidTableContext(context: DayAheadBidTableContext): string {
  return JSON.stringify({
    table: 'day-ahead-bid',
    elplanInfoId: context.elplanInfoId,
    startTime: context.startTime,
    endTime: context.endTime,
    gridIdentity: context.gridIdentity,
    scenarioId: context.scenarioId ?? 'none',
    partitionId: context.partitionId ?? 'none',
  })
}
